import React from 'react';
import EAIcon from './EAIcon';
import { ERROR, INFO, SUCCESS, WARNING } from 'services/common/Constants';

/**
 * EAIcon component with severity icon
 * @param severity ERROR | INFO | SUCCESS
 */
const EAAlertIcon = ({ severity, ...otherProps }) => {
  switch (severity) {
    case ERROR:
      return <EAIcon icon={'error-rounded'} {...otherProps} />;
    case INFO:
      return <EAIcon icon={'info-rounded'} {...otherProps} />;
    case SUCCESS:
      return <EAIcon icon={'valid-rounded'} {...otherProps} />;
    case WARNING:
      return <EAIcon icon={'warning-snack'} {...otherProps} />;
    default:
      return;
  }
};

export default EAAlertIcon;
